module.exports = "/_next/static/images/8a3b5b33ab31ee21c57f3f1f49988403-hero-lg.jpg.webp";